import request from '@/config/axios'

// 跟进记录 VO
export interface FollowUpRecordVO {
  id: number // 编号
  bizType: number // 数据类型
  bizId: number // 数据编号（bizType=2 时即客户编号）
  no: string // 单号，格式 gjjl-yyyyMMdd + 4 位自增
  customerId: number // 客户编号
  customerName: string // 客户名称
  type: number // 跟进方式（字典 crm_follow_up_type）
  followStatus: number // 跟进状态（字典 crm_follow_up_status）
  content: string // 跟进内容
  picUrls: string[] // 图片
  fileUrls: string[] // 附件
  followTime: Date // 跟进时间（列表展示为「上次跟进时间」）
  nextTime: Date // 下次联系时间
  remark: string // 跟进备注
  businessIds: number[] // 关联的商机编号数组
  businesses: {
    id: number
    name: string
  }[] // 关联的商机数组
  contactIds: number[] // 关联的联系人编号数组
  contacts: {
    id: number
    name: string
  }[] // 关联的联系人数组
  creator: string
  creatorName?: string
  creatorDeptName?: string
  createTime?: Date
}

// 跟进记录 API
export const FollowUpRecordApi = {
  // 查询跟进记录分页
  // - 传 bizId：按该条数据的数据权限过滤（详情页用）
  // - 只传 bizType + sceneType：按「客户」归属过滤（列表页用；sceneType 不传 = 全部跟进）
  getFollowUpRecordPage: async (params: any) => {
    return await request.get({ url: `/crm/follow-up-record/page`, params })
  },

  // 查询跟进记录详情
  getFollowUpRecord: async (id: number) => {
    return await request.get({ url: `/crm/follow-up-record/get?id=` + id })
  },

  // 新增跟进记录
  createFollowUpRecord: async (data: FollowUpRecordVO) => {
    return await request.post({ url: `/crm/follow-up-record/create`, data })
  },

  // 修改跟进记录
  updateFollowUpRecord: async (data: FollowUpRecordVO) => {
    return await request.put({ url: `/crm/follow-up-record/update`, data })
  },

  // 删除跟进记录
  deleteFollowUpRecord: async (id: number) => {
    return await request.delete({ url: `/crm/follow-up-record/delete?id=` + id })
  },

  // 导出跟进记录
  exportFollowUpRecord: async (params: any) => {
    return await request.download({ url: `/crm/follow-up-record/export`, params })
  }
}
